import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            name: 'login',
            component: () => import("@/core/plugins/TitleRibbon/index"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    meta:{main_page: true},
                    component: () => import("@/core/plugins/TitleRibbon/Dashboard")
                },
                {
                    path: "/routes",
                    name: "routes",
                    component: () => import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                    children: [
                        {
                            path: "/categories",
                            name: "categories",
                            meta: {
                                permission: "category_list",
                                has_ribbon: true,
                                title: "دسته بندی ها"
                            },
                            component: () => import("@/view/pages/createCategory/categoryList")
                        },
                        {
                            path: "/shop/archives",
                            name: "shop_archives",
                            meta: {
                                has_ribbon: true,
                                title: "خرید بانک اطلاعاتی"
                            },
                            component: () => import("@/view/pages/createBankPack/Banks")
                        },
                        {
                            path: "/shop/Phonearchives",
                            name: "shop_archives",
                            meta:{has_ribbon:true,title:'خرید بانک شماره همراه'},
                            component: () => import("@/view/pages/createBankPack/phoneBanks")
                        },
                        {
                            path: "/shop/boughtArchives",
                            name: "bought_archives",
                            meta:{has_ribbon:true,title:'بانک های اطلاعاتی شما'},
                            component: () => import("@/view/pages/createBankPack/boughtArchives")
                        },
                        {
                            path: "/shop/likedArchives",
                            name: "liked_archives",
                            meta:{has_ribbon:true,title:'بانک های موردعلاقه شما'},
                            component: () => import("@/view/pages/createBankPack/likedArchives")
                        },
                        {
                            path: "/admin/archives",
                            name: "admin_archives",
                            meta: {
                                permission: "archives_list",has_ribbon:true,title:'بانک ها'
                            },
                            component: () => import("@/view/pages/createBankPack/BankList")
                        },
                        {
                            path: "/admin/fileManager",
                            name: "admin_fileManager",
                            meta: {
                                permission: "admin_file_manager",has_ribbon:true,title:'مدیریت فایل ها'
                            },
                            component: () => import("@/view/pages/mainComponents/fileManager")
                        },
                        {
                            path: "/admin/new/archive",
                            name: "new_archive",
                            meta: {
                                permission: "create_archive",has_ribbon:true,title:'ایجاد بسته'
                            },
                            component: () => import("@/view/pages/createBankPack/craetePack")
                        },
                    ]
                },
            ]
        },
    ]
});
